export function normalizeCountryKey(value) {
    if (!value) return "";
    return String(value).replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
}

export function findCountryMatch(countries, countryValue) {
    if (!countryValue || !Array.isArray(countries) || countries.length === 0) {
        return null;
    }

    const key = normalizeCountryKey(countryValue);
    if (!key) return null;

    return (
        countries.find((country) => {
            return (
                normalizeCountryKey(country.displayName) === key ||
                normalizeCountryKey(country.code2) === key ||
                normalizeCountryKey(country.code3) === key
            );
        }) || null
    );
}

export function getCountryDisplayName(countries, countryValue) {
    const match = findCountryMatch(countries, countryValue);
    return match?.displayName || countryValue || "";
}
